// extracted by mini-css-extract-plugin
export var faqList = "Yr8A";
export var link = "ukOj";